
import React from 'react';
import Link from 'next/link';
import { IconType } from 'react-icons';
import {
    FaFacebookF,
    FaTwitter,
    FaInstagram,
    FaLinkedinIn,
    FaPinterestP,
    FaYoutube,
    FaTiktok,
    FaFlipboard,
    FaChevronDown,
    FaWhatsapp,
    FaTelegramPlane,
    FaStar,
    FaEnvelopeOpen,
    FaMapPin,
    FaPhone,
} from 'react-icons/fa';
import { FaShieldHalved } from 'react-icons/fa6';
import { ComponentNode } from '../types/template';
import { convertStylesToInline } from '../utils/styleUtils';
import { resolveCustomThemeHref } from '../utils/linkHelpers';

const iconMap: Record<string, IconType> = {
    FaFacebookF,
    FaTwitter,
    FaInstagram,
    FaLinkedinIn,
    FaPinterestP,
    FaYoutube,
    FaTiktok,
    FaFlipboard,
    FaChevronDown,
    FaWhatsapp,
    FaTelegramPlane,
    FaStar,
    FaEnvelopeOpen,
    FaMapPin,
    FaPhone,
    FaShieldHalved,
    'fa-chevron-down': FaChevronDown,
    'fa-facebook-f': FaFacebookF,
    'fa-twitter': FaTwitter,
    'fa-instagram': FaInstagram,
    'fa-linkedin-in': FaLinkedinIn,
    'fa-pinterest-p': FaPinterestP,
    'fa-youtube': FaYoutube,
    'fa-tiktok': FaTiktok,
    'fa-flipboard': FaFlipboard,
    'fa-whatsapp': FaWhatsapp,
    'fa-telegram': FaTelegramPlane,
    'fa-star': FaStar,
};

interface IconComponentProps {
    component: ComponentNode;
    data?: any;
    context?: {
        store_slug?: string;
        slug_type?: string;
        category_slug?: string;
        promotion_slug?: string;
        out_link?: string;
    };
}

const IconComponent: React.FC<IconComponentProps> = ({ component, data, context }) => {
    const Icon = iconMap[component.data as string];
    if (!Icon) {
        return null;
    }

    const inlineStyles = convertStylesToInline(component.styles);
    const content = <Icon style={inlineStyles} />;

    if (component.href) {
        const resolvedHref = resolveCustomThemeHref(component.href, data, context);

        if (resolvedHref) {
            return <Link href={resolvedHref}>{content}</Link>;
        }
    }

    return content;
};

export default IconComponent;